import { Link } from 'react-router-dom';

const AvisoPrivacidad = () => {
    return (
        <main className="main">
            <section className="section light-background">
                <div className="container" data-aos="fade-up">

                    <div className="row justify-content-center">
                        <div className="col-lg-8">

                            {/* <div className="mt-5 mb-4">
                                <Link to="/" className="btn-plan d-inline-flex align-items-center gap-2" style={{ textDecoration: 'none' }}>
                                    <i className="bi bi-arrow-left"></i> Volver al inicio
                                </Link>
                            </div> */}

                            <div className="section-title mt-5 mb-5">
                                <h2>Aviso de Privacidad</h2>
                                <p>Última actualización: 2025 &nbsp;·&nbsp; Ámbito de aplicación: Estados Unidos Mexicanos</p>
                            </div>

                            <div className="about-content legal-content">

                                <p className="lead mb-4">
                                    Goodlic, con domicilio en México (en adelante, "Goodlic"), es responsable del uso, protección y tratamiento
                                    de los datos personales que recaba de sus usuarios, clientes y visitantes, en cumplimiento de la Ley Federal
                                    de Protección de Datos Personales en Posesión de los Particulares, su Reglamento y demás disposiciones
                                    aplicables.
                                </p>

                                <div className="contact-card mb-4">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <p className="mb-1"><strong>Responsable:</strong> Goodlic</p>
                                            <p className="mb-0"><strong>Correo de contacto:</strong> <a href="mailto:goodlic.corp@gmail.com">goodlic.corp@gmail.com</a></p>
                                        </div>
                                    </div>
                                </div>

                                <h5 className="mb-2 mt-4">1. Datos personales recabados</h5>
                                <p>
                                    Goodlic podrá recabar datos personales de manera directa a través de formularios, suscripciones,
                                    comunicaciones electrónicas o interacción con la plataforma. Los datos recabados podrán incluir,
                                    de forma enunciativa más no limitativa:
                                </p>
                                <ul className="features-list mb-3">
                                    <li><span>Nombre completo</span></li>
                                    <li><span>Correo electrónico</span></li>
                                    <li><span>Número telefónico</span></li>
                                    <li><span>Información general relacionada con productos bancarios y financieros</span></li>
                                </ul>
                                <p>
                                    Goodlic no recaba datos personales sensibles, información patrimonial específica, contraseñas, NIP,
                                    tokens, claves de acceso a banca electrónica ni credenciales confidenciales. En caso de que el usuario
                                    proporcione voluntariamente este tipo de información, será bajo su exclusiva responsabilidad.
                                </p>

                                <h5 className="mb-2 mt-4">2. Finalidades del tratamiento</h5>
                                <p>Los datos personales serán utilizados para las siguientes finalidades primarias:</p>
                                <ul className="features-list mb-3">
                                    <li><span>Proveer servicios de orientación, información y educación bancaria y financiera</span></li>
                                    <li><span>Gestionar el registro, acceso y administración de servicios por suscripción</span></li>
                                    <li><span>Procesar pagos, renovaciones, cancelaciones y, en su caso, facturación</span></li>
                                    <li><span>Atender solicitudes, consultas y soporte técnico o administrativo</span></li>
                                    <li><span>Cumplir con obligaciones legales y contractuales</span></li>
                                </ul>
                                <p>
                                    De manera adicional, los datos podrán utilizarse para finalidades secundarias como el envío de
                                    contenido educativo, informativo o promocional. El usuario podrá oponerse a estas finalidades
                                    secundarias en cualquier momento.
                                </p>

                                <h5 className="mb-2 mt-4">3. Uso de plataformas de pago y terceros</h5>
                                <p>
                                    Los pagos de los servicios ofrecidos por Goodlic se procesan a través de plataformas de pago de
                                    terceros debidamente autorizadas. Goodlic no almacena ni tiene acceso a información bancaria,
                                    números de tarjeta, códigos de seguridad ni datos financieros sensibles. El tratamiento de dicha
                                    información se rige por los avisos de privacidad de las plataformas correspondientes.
                                </p>

                                <h5 className="mb-2 mt-4">4. Transferencia de datos</h5>
                                <p>
                                    Goodlic no vende, renta ni transfiere datos personales a terceros sin el consentimiento del titular,
                                    salvo cuando sea necesario para cumplir obligaciones legales o por requerimiento de autoridad competente.
                                </p>

                                <h5 className="mb-2 mt-4">5. Derechos ARCO</h5>
                                <p>
                                    El titular de los datos personales podrá ejercer sus derechos de Acceso, Rectificación, Cancelación
                                    u Oposición (ARCO) enviando una solicitud al correo{' '}
                                    <a href="mailto:goodlic.corp@gmail.com">goodlic.corp@gmail.com</a>.
                                    La solicitud deberá contener nombre completo, descripción clara del derecho a ejercer y medio para
                                    recibir respuesta.
                                </p>

                                <h5 className="mb-2 mt-4">6. Medidas de seguridad</h5>
                                <p>
                                    Goodlic implementa medidas administrativas, técnicas y organizacionales razonables para proteger
                                    los datos personales contra daño, pérdida, alteración, destrucción o uso, acceso o tratamiento
                                    no autorizado.
                                </p>

                                <h5 className="mb-2 mt-4">7. Modificaciones al aviso de privacidad</h5>
                                <p>
                                    Goodlic se reserva el derecho de modificar el presente Aviso de Privacidad en cualquier momento.
                                    Las modificaciones serán publicadas en el sitio web oficial.
                                </p>

                            </div>
                        </div>
                    </div>

                </div>
            </section>
        </main>
    );
};

export default AvisoPrivacidad;
